import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-brazi',
  templateUrl: './brazi.component.html',
  styleUrls: ['./brazi.component.scss']
})
export class BraziComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {



  }

}
